import LoadingComponent from '@/pages/components/loadingComponent'
import Loadable from 'react-loadable'

export default [
  {
    component: Loadable({
      loader: () => import('@/pages/widget/myWidgetBag/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/widget/myWidgetBag',
    exact: true,
    meta: {
      title: '我的道具包'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/widget/myWidgetDetail/index'),
      loading: LoadingComponent
    }),
    exact: true,
    path: '/courierView/widget/myWidgetDetail',
    meta: {
      title: '道具明细'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/widget/voidWidget/index'),
      loading: LoadingComponent
    }),
    exact: true,
    path: '/courierView/widget/voidWidget',
    meta: {
      title: '作废道具'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/widget/widgetExplain/index'),
      loading: LoadingComponent
    }),
    exact: true,
    path: '/courierView/widget/widgetExplain',
    meta: {
      title: '道具说明'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/widget/backhaulSettings/index'),
      loading: LoadingComponent
    }),
    exact: true,
    path: '/courierView/widget/backhaulSettings',
    meta: {
      title: '回程设置'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/widget/repairSigninSettings/index'),
      loading: LoadingComponent
    }),
    exact: true,
    path: '/courierView/widget/repairSigninSettings',
    meta: {
      title: '补签确认'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/widget/acceptOrderSettings/index'),
      loading: LoadingComponent
    }),
    exact: true,
    path: '/courierView/widget/acceptOrderSettings/:courierPropID',
    meta: {
      title: '接单偏好设置'
    }
  }
]
